/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Zip_FilenameInputs */



/**
* | output |
* | --- |
* | "batch-export.zip" |
*
* @param {Explorer_Info_Batch_Zip_FilenameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_zip_filename = /** @type {((inputs?: Explorer_Info_Batch_Zip_FilenameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Zip_FilenameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "de") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "it") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "ru") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "es") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "ja") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "hi") return /** @type {LocalizedString} */ ("batch-export.zip")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("batch-export.zip")
	return /** @type {LocalizedString} */ ("batch-export.zip")
});